import type {
  ProgramGroupListResponse,
  ProgramGroupRequest,
  ProgramGroupResponse,
  ProgramListResponse,
  ProgramParams,
  UpperProgramListResponse,
} from '@/domains/system-management/types/authority';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

export const authorityApi = {
  // Get program authenticated list
  getProgramAuthenticated: async (params: ProgramParams): Promise<ProgramListResponse[]> => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });
    const url = `${URLS.BACK_DSH}${APIS.programAuthenticated(queryParams.toString())}`;
    return request.get(url);
  },

  // Get upper programs
  getUpperProgram: async (): Promise<UpperProgramListResponse[]> => {
    const url = `${URLS.BACK_DSH}${APIS.upperProgram}`;
    return request.get(url);
  },

  // Get program group
  getProgramGroup: async (id: number): Promise<ProgramGroupListResponse[]> => {
    const url = `${URLS.BACK_DSH}${APIS.groupProgram(id)}`;
    return request.get(url);
  },

  // Create group authority
  createGroupAuthority: async (
    id: number,
    data: ProgramGroupRequest
  ): Promise<ProgramGroupResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.groupProgram(id)}`;
    return request.post(url, data);
  },
};
